import * as React from 'react';

import UIAsset from 'components/atoms/UIAsset';

type InfoSummaryProps = {
	title: string;
	text: string;
	extra?: {
		title: string;
		text: string;
	};
	icon?: string; // FIXME: UNSUPPORTED
	image?: string;
	modifier?: string;
};

const renderExtra = ({ title, text }) => (
	<div>
		<div className="a-info-summary__dots" />
		<div className="a-info-summary__sub">
			<span className="a-info-summary__sub-title">{title}</span>
			<span className="a-info-summary__sub-text">{text}</span>
		</div>
	</div>
);

const renderImage = (image: string) => (
	<div className="a-info-summary__image">
		<UIAsset src={`/img/svg/${image}.svg`} alt="" />
	</div>
);

const InfoSummary = ({ title, text, extra, image, modifier }: InfoSummaryProps) => (
	<div className={`a-info-summary${modifier ? ` a-info-summary--${modifier}` : ''}`}>
		<span className="a-info-summary__title">{title}</span>
		{image ? renderImage(image) : null}
		<span className="a-info-summary__text">{text}</span>
		{extra ? renderExtra(extra) : null}
	</div>
);

InfoSummary.displayName = 'InfoSummary';

export default InfoSummary;
